const RESOURCES_DATA = [
    {
        header: {
            name: 'Learning',
            tag: 'learning',
            desc: `Websites good for learning calculus and math.`
        },
        bits: [
            {
                name: 'Paul\'s Math Notes',
                href: 'http://tutorial.math.lamar.edu/Classes/CalcI/CalcI.aspx',
                desc: `Awesome website for learning calculus. 
                It has notes, practice problems, and cheat sheets.
                It is very concise and easy to digest.`
            },
            {
                name: 'Khan Academy',
                href: 'https://www.khanacademy.org/math/ap-calculus-ab',
                desc: `My sister website. 
                Khan Academy is another good website for calculus material, with videos as its strong point. 
                It also aligns with the AP curriculum.`
            },
            {
                name: 'PatrickJMT',
                href: 'http://patrickjmt.com/#calculus',
                desc: `Youtube videos for if you are having a problem with a specific concept.`
            },
        ]
    },
    {
        header: {
            name: 'Local Level MAΘ Tests',
            tag: 'locals',
            desc: `Practice tests from websites that mimic the difficulty of a local/state-level test.`
        },
        bits: [
            {
                name: 'ACTM',
                href: 'http://uca.edu/actm/regional-contest-archive/',
                desc: `Similar difficulty to Louisiana's local tournaments`
            },
            {
                name: 'LaMAΘ',
                href: 'http://www.lamao.org/Public/Tests?Year=2012',
                desc: `Louisiana's official Mu Alpha Theta website. They have some tests available, but unfortunately some are missing (you can find some of them on our site).`
            },
            {
                name: 'Collection of Differential Calculus Problems',
                href: 'http://faculty.ung.edu/jallagan/Courses%20materials/Math%201450%20Calculus%201/Syllabus%20and%20ebook/problems%20and%20solutions%20for%20calculus%201.pdf',
                desc: `Problems given at Simon Fraser University sorted by category.`
            }
        ]
    },
    {
        header: {
            name: 'National Level MAΘ Tests',
            tag: 'nationals',
            desc: `These sites are for if you are feeling ambitious. They are difficult!`
        },
        bits: [
            {
                name: 'MAΘ',
                href: 'https://www.mualphatheta.org/past_tests',
                desc: `Mu Alpha Theta's official page. They have tests from National Convention, a national-level tournament.`
            },
            {
                name: 'FAMAT',
                href: 'https://floridamao.org/FAMATSite/PublicPages/TestArchive.aspx',
                desc: `Florida's official Mu Alpha Theta website. Very tough but good tests to study to prepare for national convention.`
            },
            {
                name: 'Columbia',
                href: 'https://www.columbusstate.edu/math/tournament/previous-calculus-contest.php',
                desc: `Columbus State University's website. They have an invitational mathematics tournament with some pretty tough problems.`
            }
        ]
    },
    {
        header: {
            name: 'Miscellaneous Resources',
            tag: 'misc',
            desc: `Anything else goes here!`
        },
        bits: [
            {
                name: 'Derivative / Integral Cheat Sheet', 
                href: 'https://tutorial.math.lamar.edu/pdf/common_derivatives_integrals.pdf', 
                desc: `Common derivatives and integrals you may find in a tournament setting.`
            },
            {
                name: 'Common Calculus Mistakes', 
                href: 'https://calculus.nipissingu.ca/mistakes.html', 
                desc: `Common calculus mistakes that students make.`
            },
            {
                name: 'Last Minute Tips', 
                href: require('../tests/last_minute_tips.pdf'), 
                desc: `Common mistakes and stuff that I noticed from my own tournament experience.`
            },
            {
                name: 'MathIM Lobby', 
                href: 'https://mathim.com/', 
                desc: `A chatroom that supports rendered math text.`
            },
            {
                name: 'Polar Graph Sheet', 
                href: require('../tests/polar_review.pdf'), 
                desc: `The common polar graph sheet, compliments of Mr. Hernandez. I've really grown fond of this page.`
            },
            {
                name: 'Desmos', 
                href: 'https://www.desmos.com/', 
                desc: `Really good for graphing math. You can use it to check answers for your questions too!`
            },
            {
                name: 'Brilliant', 
                href: 'https://brilliant.org/wiki/wiki-guidelines/', 
                desc: `Really clean math wiki pages. For example, I really like their page on "Vieta's" and "Telescoping Series."`
            },
        ]
    },
    {
        header: {
            name: 'Collegeboard AP Exam',
            tag: 'ap',
            desc: `This is not for Mu Alpha Theta, but for those prepping for the AP Calculus exam.`
        },
        bits: [
            {
                name: 'AP Calculus AB Exam Page', 
                href: 'https://apcentral.collegeboard.org/courses/ap-calculus-ab/exam', 
                desc: `AP Calculus AB main page with information.`
            },
            {
                name: 'AP Calculus AB FRQs', 
                href: 'https://apcentral.collegeboard.org/courses/ap-calculus-ab/exam/past-exam-questions', 
                desc: `Past AP Calculus free response questions.`
            },
            {
                name: 'AP Week Dates', 
                href: 'https://apcentral.collegeboard.org/courses/exam-dates-and-fees/exam-dates-2020', 
                desc: `Which exams are on which day? For reference, both Calculus AB and BC are on Monday, May 9, 2022.`
            },
            {
                name: 'AP Calculus AB and BC Course and Exam Description', 
                href: 'https://apcentral.collegeboard.org/pdf/ap-calculus-ab-bc-course-and-exam-description-0.pdf?course=ap-calculus-ab', 
                desc: `More AP information.`
            },
            {
                name: 'AP Calculus Content Outline (2019)', 
                href: require('../tests/ap/outline.pdf'), 
                desc: `Content outline for both AP Calculus AB and BC.`
            },
            {
                name: 'AP Calculus Cheat Sheet', 
                href: require('../tests/ap/apcalccheatsheet.pdf'), 
                desc: `Cheat sheet for both AB and BC Calculus.`
            },
            {
                name: 'Calc BC Cheat Sheet', 
                href: require('../tests/ap/bccram.pdf'), 
                desc: `Cheat sheet specifically for BC students.`
            },
            {
                name: 'Calculus Study Guide', 
                href: require('../tests/ap/apcalcsectionreview.pdf'), 
                desc: `A study guide that covers material by sections.`
            }
        ]
    },
    {
        header: {
            name: 'AMC/AIME',
            tag: 'amc',
            desc: `This is not for Mu Alpha Theta, but for those interested here are resources for tackling the AMC/AIME. These are focused on problem-solving rather than knowledge/content. The four main topics are algebra, geometry, combinatorics, and number theory.`
        },
        bits: [
            {
                name: 'AoPS Wiki', 
                href: 'https://artofproblemsolving.com/wiki/', 
                desc: `A large math wiki full of resources!`
            },
            {
                name: 'AoPS Forums', 
                href: 'https://artofproblemsolving.com/community', 
                desc: `A forum for discussing math competition stuff!`
            },
            {
                name: 'AMC FAQs', 
                href: 'https://www.maa.org/math-competitions/faqs', 
                desc: `FAQs by the Mathematical Association of America (MAA).`
            },
            {
                name: 'How to Prepare', 
                href: 'https://artofproblemsolving.com/wiki/index.php/How_should_I_prepare%3F', 
                desc: `AoPS wikipage that gives good advice on how to prepare for the AMC.`
            },
            {
                name: 'AMC 12 Problems and Solutions', 
                href: 'https://artofproblemsolving.com/wiki/index.php?title=AMC_12_Problems_and_Solutions', 
                desc: `Your best resource for the AMC, past AMC tests!`
            },
            {
                name: 'Algebra Outline', 
                href: 'https://artofproblemsolving.com/wiki/index.php/Algebra/Intermediate', 
                desc: `List of intermediate algebra topics. Very good for AMC review.`
            },
            {
                name: 'Combinatorics Outline', 
                href: 'https://artofproblemsolving.com/wiki/index.php?title=Combinatorics/Introduction', 
                desc: `List of introductory combinatorics topics.`
            },
            {
                name: 'Number Theory Outline', 
                href: 'https://artofproblemsolving.com/wiki/index.php/Number_theory/Introduction', 
                desc: `List of introductory number theory topics.`
            },
            {
                name: 'AMC 12 Formulas', 
                href: 'https://www.tempeunion.org/cms/lib/AZ01901094/Centricity/Domain/520/AMC%2012%20Study%20Guide.pdf', 
                desc: `Has important identities and formulas that can be present on AMC.`
            },
            {
                name: 'AMC 12 Breakdown', 
                href: 'https://artofproblemsolving.com/wiki/index.php/AMC_12', 
                desc: `Tells you how many questions, how much each question is worth, what is allowed on the test, the difficulty breakdown, etc.`
        
            },
            {
                name: 'AMC Statistics', 
                href: 'https://amc-reg.maa.org/reports/generalreports.aspx', 
                desc: `See how you compare with the rest of the nation.`
            }
        ]
    },
    {
        header: {
            name: 'Other Competition Math Resources',
            tag: 'other',
            desc: `Other competition-type math or puzzles to stimulate yourself. 
            They can help you prepare for the AMC/AIME as well!`
        },
        bits: [
            {
                name: 'All of Math in Three Pages', 
                href: 'http://www.mandelbrot.org/resources/forms/indivtopics.pdf', 
                desc: `Content outline of "high school mathematics".`
            },
            {
                name: 'Coastal', 
                href: 'https://www.coastal.edu/math/mathcontest/tests/', 
                desc: `Coastal Carolina University's HS math contest. These problems are easier than the AMC, but are good for brushing up.`
            },
            {
                name: 'UI Math Contest', 
                href: 'https://faculty.math.illinois.edu/~hildebr/putnam/localcontestproblems.html', 
                desc: `Math Contest problems from University of Illinois!`
            },
            
            {
                name: 'David Altizio', 
                href: 'http://www.andrew.cmu.edu/user/daltizio/mathstuff.html', 
                desc: `Includes problem sets and really cool Math League handouts.`
            },
            {
                name: 'Contest Geometry', 
                href: 'http://www.geometer.org/mathcircles/geometry.pdf', 
                desc: `Contains important formulas and theorems from plane Euclidean geometry that are useful in math contests.`
            },
            {
                name: 'Nick\'s Math Puzzles', 
                href: 'http://www.qbyte.org/puzzles/', 
                desc: `Stimulate your brain with some math puzzles.`
            },
        ]
    },
]

export default RESOURCES_DATA;